import { combineReducers } from '@reduxjs/toolkit';
import getMessagesSlice from './getMessagesSlice';
import updateMessageSlice from './updateMessagesSlice';

export default combineReducers({
    listMessage: getMessagesSlice,
    updateMessageFlag: updateMessageSlice,
});
